(function () {
  if (window.gsFacetsInit) return;
  window.gsFacetsInit = true;

  var CONTAINER = 'ProductGridContainer';
  var cache = {};
  var drawerOpen = false;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  function form() { return document.getElementById('GsFacetForm'); }
  function drawer() { return document.querySelector('[data-gs-facets-drawer]'); }

  function sectionId() {
    var host = document.querySelector('gs-facets');
    if (host && host.dataset.section) return host.dataset.section;
    var grid = document.getElementById('product-grid');
    return grid ? grid.dataset.id : null;
  }

  // the scrim sits next to the drawer instead of on the body, so both share one
  // stacking context and the drawer is always drawn on top of it
  function getScrim() {
    var d = drawer();
    if (!d || !d.parentNode) return null;
    var existing = d.previousElementSibling;
    if (existing && existing.classList.contains('gs-facets__scrim')) return existing;
    var el = document.createElement('div');
    el.className = 'gs-facets__scrim';
    el.addEventListener('click', function () {
      setDrawer(false);
      closePanels(null);
      setScrim(false);
    });
    d.parentNode.insertBefore(el, d);
    return el;
  }

  function setScrim(open) {
    var s = getScrim();
    if (s) s.classList.toggle('is-open', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function setDrawer(open) {
    drawerOpen = open;
    var d = drawer();
    if (d) d.classList.toggle('is-open', open);
    setScrim(open);
  }

  function closePanels(except) {
    document.querySelectorAll('[data-gs-facet].is-open').forEach(function (el) {
      if (el !== except) el.classList.remove('is-open');
    });
  }

  function markLoading(on) {
    var count = document.getElementById('ProductCount');
    if (count) count.classList.toggle('is-loading', on);
    var grid = document.getElementById('product-grid');
    if (grid) grid.classList.toggle('loading', on);
  }

  function searchParamsFromForm() {
    var f = form();
    if (!f) return '';
    var params = new URLSearchParams(new FormData(f));

    params.forEach(function (value, key) {
      if (value === '') params.delete(key);
    });

    // a range at its full extent is not a filter, so keep it out of the URL
    if (params.get('filter.v.price.gte') === '0') params.delete('filter.v.price.gte');
    var maxInput = f.querySelector('[data-gs-price-max]');
    if (maxInput && params.get('filter.v.price.lte') === maxInput.dataset.gsPriceMax) {
      params.delete('filter.v.price.lte');
    }
    return params.toString();
  }

  function render(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.getElementById(CONTAINER);
    var target = document.getElementById(CONTAINER);
    if (!source || !target) return;

    target.innerHTML = source.innerHTML;
    markLoading(false);
    setupPin();
    syncAllPrices();

    if (drawerOpen && window.matchMedia('(max-width: 999px)').matches) {
      var d = drawer();
      if (d) {
        // skip the entry transition, the sheet was already open
        d.style.transition = 'none';
        d.classList.add('is-open');
        void d.offsetWidth;
        d.style.transition = '';
      }
    } else {
      setDrawer(false);
    }
  }

  function renderPage(params, push) {
    var id = sectionId();
    if (!id) return;
    markLoading(true);

    var url = window.location.pathname + '?section_id=' + id + (params ? '&' + params : '');

    if (push !== false) {
      history.pushState({ gsParams: params }, '', window.location.pathname + (params ? '?' + params : ''));
    }

    if (cache[url]) { render(cache[url]); return; }

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) { cache[url] = html; render(html); })
      .catch(function () { markLoading(false); });
  }

  var onInput = debounce(function () { renderPage(searchParamsFromForm()); }, 400);

  function syncPrice(group) {
    if (!group) return;
    var min = group.querySelector('[data-gs-price-role="min"]');
    var max = group.querySelector('[data-gs-price-role="max"]');
    var fill = group.querySelector('[data-gs-price-fill]');
    if (!min || !max) return;

    var lo = parseInt(min.value, 10);
    var hi = parseInt(max.value, 10);
    if (lo > hi) {
      if (document.activeElement === min) { lo = hi; min.value = hi; }
      else { hi = lo; max.value = lo; }
    }

    var ceiling = parseInt(group.dataset.gsPriceCeiling, 10) || 1;
    if (fill) {
      fill.style.left = (lo / ceiling * 100) + '%';
      fill.style.right = (100 - hi / ceiling * 100) + '%';
    }
    var outMin = group.querySelector('[data-gs-price-out="min"]');
    var outMax = group.querySelector('[data-gs-price-out="max"]');
    if (outMin) outMin.textContent = lo;
    if (outMax) outMax.textContent = hi;
  }

  function syncAllPrices() {
    document.querySelectorAll('[data-gs-price]').forEach(syncPrice);
  }

  document.addEventListener('input', function (e) {
    if (!e.target.closest || !e.target.closest('#GsFacetForm')) return;
    if (e.target.type === 'range') { syncPrice(e.target.closest('[data-gs-price]')); return; }
    onInput();
  });

  document.addEventListener('change', function (e) {
    if (e.target.type !== 'range') return;
    if (!e.target.closest('#GsFacetForm')) return;
    renderPage(searchParamsFromForm());
  });

  document.addEventListener('change', function (e) {
    var option = e.target.closest ? e.target.closest('.gs-facet__option') : null;
    if (!option) return;
    var group = option.closest('.gs-facet__list');
    if (group && e.target.type === 'radio') {
      group.querySelectorAll('.gs-facet__option').forEach(function (el) { el.classList.remove('is-selected'); });
    }
    option.classList.toggle('is-selected', e.target.checked);
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-gs-facet-trigger]');
    if (trigger) {
      var facet = trigger.closest('[data-gs-facet]');
      var willOpen = !facet.classList.contains('is-open');
      closePanels(facet);
      facet.classList.toggle('is-open', willOpen);
      if (facet.classList.contains('gs-facet--sort') && window.matchMedia('(max-width: 999px)').matches) {
        setScrim(willOpen);
      }
      return;
    }

    if (e.target.closest('[data-gs-facets-open]')) { setDrawer(true); return; }
    if (e.target.closest('[data-gs-facets-close]')) { setDrawer(false); return; }

    var remove = e.target.closest('[data-gs-facet-remove], [data-gs-facet-clear]');
    if (remove) {
      e.preventDefault();
      var href = remove.getAttribute('href') || '';
      var q = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
      renderPage(q);
      return;
    }

    if (!e.target.closest('[data-gs-facet-panel]')) closePanels(null);
  });

  // an open panel travels with the sticky bar, so close it once the user scrolls on
  var lastY = window.scrollY;
  window.addEventListener('scroll', function () {
    if (Math.abs(window.scrollY - lastY) < 120) return;
    lastY = window.scrollY;
    if (drawerOpen) return;
    closePanels(null);
  }, { passive: true });


  // position: sticky is unusable here because an ancestor in the theme clips
  // overflow, so the bar is fixed by hand and measured against its own column.
  var pinObserver = null;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseInt(raw, 10) || 0;
  }

  function bar() { return document.querySelector('.gs-facets__bar'); }

  function setPinned(on) {
    var el = bar();
    var sentinel = document.querySelector('.gs-facets__sentinel');
    var spacer = document.querySelector('.gs-facets__spacer');
    if (!el || !sentinel || !spacer) return;

    if (on) {
      var rect = sentinel.getBoundingClientRect();
      spacer.style.height = el.offsetHeight + 'px';
      spacer.classList.add('is-active');
      el.style.left = rect.left + 'px';
      el.style.width = rect.width + 'px';
      el.style.top = headerOffset() + 'px';
      el.classList.add('is-pinned');
    } else {
      el.classList.remove('is-pinned');
      el.style.left = '';
      el.style.width = '';
      el.style.top = '';
      spacer.classList.remove('is-active');
      spacer.style.height = '';
    }
  }

  function setupPin() {
    var el = bar();
    if (!el || !el.parentNode) return;
    if (pinObserver) { pinObserver.disconnect(); pinObserver = null; }

    var sentinel = document.createElement('div');
    sentinel.className = 'gs-facets__sentinel';
    sentinel.style.cssText = 'height:1px;margin:0;padding:0;';
    el.parentNode.insertBefore(sentinel, el);

    var spacer = document.createElement('div');
    spacer.className = 'gs-facets__spacer';
    el.parentNode.insertBefore(spacer, el.nextSibling);

    pinObserver = new IntersectionObserver(function (entries) {
      setPinned(!entries[0].isIntersecting);
    }, { rootMargin: '-' + (headerOffset() + 1) + 'px 0px 0px 0px', threshold: 0 });

    pinObserver.observe(sentinel);
  }

  window.addEventListener('resize', function () {
    if (bar() && bar().classList.contains('is-pinned')) setPinned(true);
  });

  function init() { setupPin(); syncAllPrices(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawerOpen) { setDrawer(false); return; }
    closePanels(null);
    setScrim(false);
  });

  window.addEventListener('popstate', function (e) {
    var params = e.state && typeof e.state.gsParams === 'string'
      ? e.state.gsParams
      : window.location.search.slice(1);
    renderPage(params, false);
  });
})();